module.exports = __webpack_public_path__ + "static/media/play-replay.fb83c89b.mp3";